// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2GKNv","col":"styles_col__fMMOD","fulfillmentStatus":"styles_fulfillmentStatus__2zCnm","emailCol":"styles_emailCol__3SVtk"};